// witer_dark_theme.js
import { EditorView } from '@codemirror/view';

// Tailwind gray-950 and white
const background = '#030712'; // Tailwind gray-950
const textColor = '#ffffff'; // White

export const witerDarkTheme = EditorView.theme(
  {
    '&': {
      backgroundColor: background,
      color: textColor,
      minHeight: '0 !important', // Ensure no min-height (addresses 200px issue)
      height: 'auto !important'
    },
    '.cm-content': {
      caretColor: textColor, // White caret for visibility
      minHeight: '0 !important'
    },
    '.cm-scroller': {
      backgroundColor: background,
      minHeight: '0 !important',
      overflow: 'hidden'
    }
  },
  { dark: true }
);

// Export the theme as a single extension (no highlighting)
export const witerDark = [witerDarkTheme];
